export const root    = '/';
export const home    = '/בית';
export const login   = '/login';
export const signup  = '/signup';
export const contact = '/צור_קשר';
export const about   = '/אודותינו';
export const results = '/תוצאות';
export const car     = '/רכב';
export const Order   = '/הזמנה';
export const howItWorks ='/איך_זה_עובד';
export const content =  '/תוכן';
export const qa      =  '/שאלות_ותשובות';
export const error   =  '/404';
export const match   = '/שאלון';
export const placeholder = '/שיפוץ';